<div class="item__description ms-3">
  <button mat-raised-button color="accent" (click)="click()">Book</button>
</div>